import { SearchCardForm } from 'core/tarjeta/components/SearchCardForm/SearchCardForm';
import { CardTotalsSearchContext } from 'core/tarjeta/contexts/CardTotalsSearchContext';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export function CardTotalsSearchPage(props: { isPrevious?: boolean }) {
  const { searchCardNumber, cardNumber } = useContext(CardTotalsSearchContext);

  return (
    <Container>
      <Row>
        <Col>
          <SearchCardForm
            isPrevious={props.isPrevious}
            cardNumber={cardNumber}
            searchCardNumber={searchCardNumber}
          />
        </Col>
      </Row>
    </Container>
  );
}
